export const GROUP_CATEGORY_ORDER = ['Program', 'Campus', 'Program-Campus', 'Cohort', 'Survey Assignment'];

export function getGroupCategoryName(group) {
    if (!group) {
        return null;
    }

    return group.category?.name || group.category_name || null;
}

export function dedupeGroups(groups) {
    const seen = new Set();

    return (groups || []).filter(group => {
        if (!group?.id || seen.has(group.id)) {
            return false;
        }

        seen.add(group.id);

        return true;
    });
}

export function formatGroupCategoryTagLabel(category, names) {
    const normalizedNames = (names || []).filter(Boolean);

    if (!normalizedNames.length) {
        return '';
    }

    if (!category) {
        return normalizedNames.join(', ');
    }

    return `${category}: ${normalizedNames.join(', ')}`;
}

export function formatGroupChipLabel(group) {
    if (!group) {
        return '';
    }

    const categoryName = getGroupCategoryName(group);

    if (categoryName) {
        return `${categoryName}: ${group.name}`;
    }

    return group.name || '';
}

function buildCategoryTag(category, names) {
    const normalizedCategory = category || null;

    return {
        id: normalizedCategory || '__uncategorized__',
        category: normalizedCategory,
        names,
        label: formatGroupCategoryTagLabel(normalizedCategory, names),
    };
}

export function groupCategoryTagsFromGroups(groups) {
    const uniqueGroups = dedupeGroups(groups);
    const namesByCategory = new Map();

    for (const group of uniqueGroups) {
        const category = getGroupCategoryName(group) || '';
        const names = namesByCategory.get(category) || [];

        names.push(group.name);
        namesByCategory.set(category, names);
    }

    for (const names of namesByCategory.values()) {
        names.sort((left, right) => left.localeCompare(right));
    }

    const tags = [];

    for (const category of GROUP_CATEGORY_ORDER) {
        const names = namesByCategory.get(category);

        if (names?.length) {
            tags.push(buildCategoryTag(category, names));
            namesByCategory.delete(category);
        }
    }

    const remainingCategories = [...namesByCategory.keys()].sort((left, right) => left.localeCompare(right));

    for (const category of remainingCategories) {
        const names = namesByCategory.get(category);

        if (names?.length) {
            tags.push(buildCategoryTag(category || null, names));
        }
    }

    return tags;
}

export function groupCategoryTagsFromUserGroups(userGroups) {
    const groups = (userGroups || []).map(userGroup => userGroup?.group).filter(Boolean);

    return groupCategoryTagsFromGroups(groups);
}
